export const seasonalDiscount = {
  enabled: true,
  name: "Loyalty Discount",
  percent: 30,
};

export const getCustomerDiscountName = (loyaltyProgress, fallback = "Discount") => (
  String(loyaltyProgress?.discountName || "").trim() || fallback
);

export const getDiscountDisplayName = (name, fallback = "discount") => {
  const displayName = String(name || "").trim();

  if (!displayName) return fallback;
  if (/referral/i.test(displayName)) return displayName;
  if (/loyalty|summer|back[ -]to[ -]school|seasonal/i.test(displayName)) {
    return "Loyalty Discount";
  }

  return displayName;
};

export const roundMoney = (amount) => (
  Math.round((Number(amount || 0) + Number.EPSILON) * 100) / 100
);

export const applySeasonalDiscount = (amount, {
  additionalPercent = 0,
  additionalName = "",
  additionalType = "",
  baseName = seasonalDiscount.name,
} = {}) => {
  const originalPrice = roundMoney(amount);
  const resolvedBaseName = String(baseName || seasonalDiscount.name).trim() || seasonalDiscount.name;

  if (!seasonalDiscount.enabled || originalPrice <= 0) {
    return {
      price: originalPrice,
      discount: null,
    };
  }

  const safeAdditionalPercent = Math.max(0, Number(additionalPercent) || 0);
  const totalPercent = Math.min(100, seasonalDiscount.percent + safeAdditionalPercent);
  const normalizedAdditionalType = String(additionalType || "").toLowerCase();
  const isLoyaltyDiscount = normalizedAdditionalType === "loyalty";
  const isFirstOrderReferralDiscount = normalizedAdditionalType.includes("referral");
  const displayName = safeAdditionalPercent > 0
    ? isLoyaltyDiscount
      ? resolvedBaseName
      : isFirstOrderReferralDiscount
        ? "First-Order Referral Discount"
        : `${resolvedBaseName} + ${additionalName || "Additional Discount"}`
    : resolvedBaseName;
  const discountAmount = roundMoney(originalPrice * (totalPercent / 100));
  const discountedPrice = roundMoney(originalPrice - discountAmount);
  const components = [
    {
      name: resolvedBaseName,
      type: "seasonal",
      percent: seasonalDiscount.percent,
      amount: roundMoney(originalPrice * (seasonalDiscount.percent / 100)),
    },
  ];

  if (safeAdditionalPercent > 0) {
    components.push({
      name: additionalName || "New customer referral discount",
      type: additionalType || "referral",
      percent: safeAdditionalPercent,
      amount: roundMoney(originalPrice * (safeAdditionalPercent / 100)),
    });
  }

  return {
    price: discountedPrice,
    discount: {
      name: displayName,
      percent: totalPercent,
      amount: discountAmount,
      originalPrice,
      components,
    },
  };
};
